import React from 'react';
import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container container grid">
        <ul className="footer__links">
          {/* <li><a href="#about" className="footer__link">About</a></li>
          <li><a href="#services" className="footer__link">LoRe</a></li>
          <li><a href="#project" className="footer__link">Fuatures</a></li> */}
        </ul>

        <span className="footer__copy">
          &#169; All Rights Reserved By <a href="">Traki.</a>
        </span>
        <span className="footer__copy">
           Facing technical difficulties? Reach out to our support team for fast and reliable assistance
         <br />
         <br />
            <a href="tel:+917879137990" className="footer__phone">
          📞 +917879137990
          </a>
          &nbsp;&nbsp;
          &nbsp;&nbsp;
          <a href="mailto:trakiiteam@gmail.com">trakiiteam@gmail.com</a>
        </span>

       <span className="footer__copy">
     <Link to="/privacy-policy">Privacy Policy</Link> 
        </span>

        <span className="footer__copy"> 
      <Link to="/refund-policy">Refund Policy</Link> 
        </span>

        <span className="footer__copy">
      <Link to="/terms-and-conditions">Terms & Conditions</Link>
        </span>
        <span className="footer__copy">
      <p>Your growth is our priority</p>
        </span>

      </div>
    </footer>
  );
}
